import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Grid, Image } from "semantic-ui-react";
import LoadComponent from "../../../../app/layout/LoadComponent";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import ComparizonTile from "../ComparizonTile";
import GeneralProgress from "../GeneralProgress";
import PlanTile from "../PlanTile";
import ProgressByCategory from "../ProgressByCategory";
import SolvedQuestionsTile from "../SolvedQuestionsTile";
import WinFailTile from "../WinFailTile";
import { BannerFormValues } from "../../../../app/models/banner";
import { IUserPlan } from "../../../../app/models/userPlan";

const StudentDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;
  const { loadData, loadingInitial } = rootStore.studentDashboardStore;
  const { loadBannerByCode } = rootStore.bannerStore;
  const { currentPlan } = rootStore.userPlanStore;

  const [userPlan, setUserPlan] = useState<IUserPlan>();
  const [banner, setBanner] = useState(new BannerFormValues());

  useEffect(() => {
    loadData("0");
    currentPlan().then((result) => setUserPlan(result));
    loadBannerByCode("DASHBOARD").then((banner) =>
      setBanner(new BannerFormValues(banner))
    );
  }, [loadData, currentPlan, loadBannerByCode]);

  if (loadingInitial)
    return <LoadComponent content="Carregando informações..." />;

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={10}>
          <h1>Página Inicial</h1>
        </Grid.Column>
        <Grid.Column width={6} textAlign="right" verticalAlign="bottom">
          <h2>Bem-vindo, {user!.displayName}</h2>
        </Grid.Column>
      </Grid.Row>
      {!userPlan && banner && (
        <Grid.Row>
          <Grid.Column width={16}>
            <a
              href={banner.redirectUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image src={banner.url} />
            </a>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Grid.Column width={16}>
          <Grid columns={4}>
            <Grid.Row>
              <Grid.Column>
                <PlanTile />
              </Grid.Column>
              <Grid.Column>
                <SolvedQuestionsTile />
              </Grid.Column>
              <Grid.Column>
                <WinFailTile />
              </Grid.Column>
              <Grid.Column>
                <ComparizonTile />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <ProgressByCategory />
        </Grid.Column>
        <Grid.Column width={8}>
          <GeneralProgress />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default observer(StudentDashboard);
